import React from "react";
import PropTypes from "prop-types";

export default class Actions extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  render() {
    const { children } = this.props;

    return (
      <div className="card-actions">
        {children}
      </div>
    );
  }
}
